import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import * as config from 'config';

const localResources = {};

/*
// English local translation
import EN_COMMON from '../localization/translations/en/common/translation.json';
import EN_ACCOUNT from '../localization/translations/en/account/translation.json';
import EN_AUTH from '../localization/translations/en/auth/translation.json';
import EN_HOME from '../localization/translations/en/home/translation.json';
import EN_SEARCH from '../localization/translations/en/search/translation.json';
import EN_RECOMMENDATION from '../localization/translations/en/recommendation/translation.json';
import EN_COLLECTIONS from '../localization/translations/en/collections/translation.json';
import EN_ADMIN from '../localization/translations/en/admin/translation.json';
import EN_ANALYTICS from '../localization/translations/en/analytics/translation.json';
import EN_SETTINGS from '../localization/translations/en/settings/translation.json';

// German local translation
import DE_COMMON from '../localization/translations/de/common/translation.json';
import DE_ACCOUNT from '../localization/translations/de/account/translation.json';
import DE_AUTH from '../localization/translations/de/auth/translation.json';
import DE_HOME from '../localization/translations/de/home/translation.json';
import DE_SEARCH from '../localization/translations/de/search/translation.json';
import DE_RECOMMENDATION from '../localization/translations/de/recommendation/translation.json';
import DE_COLLECTIONS from '../localization/translations/de/collections/translation.json';
import DE_ADMIN from '../localization/translations/de/admin/translation.json';
import DE_ANALYTICS from '../localization/translations/de/analytics/translation.json';
import DE_SETTINGS from '../localization/translations/de/settings/translation.json';

// Spanish local translation
import ES_COMMON from '../localization/translations/es/common/translation.json';
import ES_ACCOUNT from '../localization/translations/es/account/translation.json';
import ES_AUTH from '../localization/translations/es/auth/translation.json';
import ES_HOME from '../localization/translations/es/home/translation.json';
import ES_SEARCH from '../localization/translations/es/search/translation.json';
import ES_RECOMMENDATION from '../localization/translations/es/recommendation/translation.json';
import ES_COLLECTIONS from '../localization/translations/es/collections/translation.json';
import ES_ADMIN from '../localization/translations/es/admin/translation.json';
import ES_ANALYTICS from '../localization/translations/es/analytics/translation.json';
import ES_SETTINGS from '../localization/translations/es/settings/translation.json';

// French local translation
import FR_COMMON from '../localization/translations/fr/common/translation.json';
import FR_ACCOUNT from '../localization/translations/fr/account/translation.json';
import FR_AUTH from '../localization/translations/fr/auth/translation.json';
import FR_HOME from '../localization/translations/fr/home/translation.json';
import FR_SEARCH from '../localization/translations/fr/search/translation.json';
import FR_RECOMMENDATION from '../localization/translations/fr/recommendation/translation.json';
import FR_COLLECTIONS from '../localization/translations/fr/collections/translation.json';
import FR_ADMIN from '../localization/translations/fr/admin/translation.json';
import FR_ANALYTICS from '../localization/translations/fr/analytics/translation.json';
import FR_SETTINGS from '../localization/translations/fr/settings/translation.json'

const localResources = {
  en: {
    common: EN_COMMON,
    account: EN_ACCOUNT,
    auth: EN_AUTH,
    home: EN_HOME,
    search: EN_SEARCH,
    recommendation: EN_RECOMMENDATION,
    collections: EN_COLLECTIONS,
    admin: EN_ADMIN,
    analytics: EN_ANALYTICS,
    settings: EN_SETTINGS,
  },
  de: {
    common: DE_COMMON,
    account: DE_ACCOUNT,
    auth: DE_AUTH,
    home: DE_HOME,
    search: DE_SEARCH,
    recommendation: DE_RECOMMENDATION,
    collections: DE_COLLECTIONS,
    admin: DE_ADMIN,
    analytics: DE_ANALYTICS,
    settings: DE_SETTINGS,
  },
  es: {
    common: ES_COMMON,
    account: ES_ACCOUNT,
    auth: ES_AUTH,
    home: ES_HOME,
    search: ES_SEARCH,
    recommendation: ES_RECOMMENDATION,
    collections: ES_COLLECTIONS,
    admin: ES_ADMIN,
    analytics: ES_ANALYTICS,
    settings: ES_SETTINGS,
  },
  fr: {
    common: FR_COMMON,
    account: FR_ACCOUNT,
    auth: FR_AUTH,
    home: FR_HOME,
    search: FR_SEARCH,
    recommendation: FR_RECOMMENDATION,
    collections: FR_COLLECTIONS,
    admin: FR_ADMIN,
    analytics: FR_ANALYTICS,
    settings: FR_SETTINGS,
  },
};
*/

const debug = false; // If TRUE load from LOCAL, if FALSE follow the root eg. staging or production dashboard.
const resourceConfig = debug
  ? { resources: localResources }
  : {
      backend: {
        backends: [LocalStorageBackend, HttpBackend],
        backendOptions: [
          {
            expirationTime: 2 * 60 * 60 * 1000, // 2 hours
          },
          {
            loadPath: `${config.root}localization/translations/{{lng}}/{{ns}}/translation.json`,
          },
        ],
        crossDomain: true,
      },
    };

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(ChainedBackend)
  .init({
    fallbackLng: debug ? false : 'en',
    ...resourceConfig,
    debug,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
